import '@gl/lit/components/base/icon/index.js';
import '@gl/lit/components/base/brand_button/index.js';

import {html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {FlywheelComponent} from '@gl/lit/lib/component.js';
import styles from './style.scss';
import {NavEvents} from '@gl/lit/types/events.js';

export const INVITATION_BUTTON_ELEMENT_TAG = 'invitation-button';

/**
 * Button used for inviting teammates.
 */
@customElement(INVITATION_BUTTON_ELEMENT_TAG)
export default class InvitationButton extends FlywheelComponent {
  @state()
  collapsed = false;

  beforeLoad() {
    const settings = JSON.parse(localStorage.getItem('settings') || '{}');
    if (settings['navCollapse']) this.collapsed = true;

    window.addEventListener(NavEvents.TOGGLE_COLLAPSE, (e: Event) => {
      const event = e as CustomEvent<{collapsed: boolean}>;
      this.collapsed = !!event.detail.collapsed;
      this.requestUpdate();
    });
  }

  static get styles() {
    return [styles];
  }

  render() {
    if (this.collapsed) {
      return html`
        <fly-list-item hasIcon large>
          <div slot="icon">
            <fly-icon icon="forward_to_inbox"></fly-icon>
          </div>
        </fly-list-item>
      `;
    }

    // we use css to hide or show the full / icon depending on the screen width
    return html`
      <div class="invitation-button__full">
        <fly-brand-button alt="Invite teammates button" icon="invite"
          >Invite teammates</fly-brand-button
        >
      </div>
      <div class="invitation-button__icon">
        <fly-list-item hasIcon large>
          <div slot="icon">
            <fly-icon icon="forward_to_inbox"></fly-icon>
          </div>
        </fly-list-item>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [INVITATION_BUTTON_ELEMENT_TAG]: InvitationButton;
  }
}
